import { useEffect, useRef, useState } from 'react';

import { format as formatFn } from 'date-fns';

import { TUseTimer } from './types';

export const useTimer: TUseTimer = ({
  durationInSec,
  format = 'mm:ss',
  onStop,
}) => {
  const [timeRemaining, setTimeRemaining] = useState(durationInSec);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);
  const endTimeRef = useRef(null);

  useEffect(() => {
    if (isRunning) {
      endTimeRef.current = new Date().getTime() + timeRemaining * 1000;
      const tick = () => {
        const currentTime = new Date().getTime();
        const time = (endTimeRef.current - currentTime) / 1000;
        setTimeRemaining(Math.ceil(time));
      };
      intervalRef.current = setInterval(tick, 1000);
    } else if (!isRunning && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isRunning]);

  useEffect(() => {
    if (timeRemaining === 0 && isRunning) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setIsRunning(false);
      onStop?.();
    }
  }, [timeRemaining, isRunning]);

  const start = () => {
    setIsRunning(true);
  };
  const stop = () => {
    setIsRunning(false);
  };
  const reset = () => {
    setIsRunning(false);
    setTimeRemaining(durationInSec);
  };

  useEffect(() => {
    setTimeRemaining(durationInSec);
  }, [durationInSec]);
  return {
    isRunning,
    start,
    stop,
    reset,
    timeInMs: timeRemaining > 0 ? timeRemaining * 1000 : 0,
    time: formatFn(timeRemaining > 0 ? timeRemaining * 1000 : 0, format),
  };
};
